import {API_URL} from "./envParams";

export const axiosConfig = {
  baseURL: API_URL,
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
};
